import { MenuType } from "@/types/header.type";

const header: MenuType[] = [
  {
    title: "Brands",
    url: "",
    nodes: [
      {
        title: "Apple",
        url: "category/apple",
        image: "storage/7fe6855b318a21cf50a83cebd984ba81/Apple.webp",
        nodes: [
          {
            title: "Apple Vision Pro",
            url: "product/apple-vision-pro",
            image:
              "storage/1c4a3d05943c3c0e09234f027a1d4ec6/Apple%20Vision%20Pro.webp",
          },
        ],
      },
      // {
      //   title: "DJI",
      //   url: "category/dji",
      //   image: "storage/12fba20d9820710b16051ce64de3d83e/DJI.webp",
      //   nodes: [
      //     {
      //       title: "DJI Mini 5 Pro fly more combo Plus",
      //       url: "product/dji-mini-5-pro",
      //       image: "storage/6878b8de941f286712bf2eb1f0091d3a/Dji-5-pro.webp",
      //     },
      //     {
      //       title: "DJI Mavic 4 Pro Fly More Combo",
      //       url: "product/dji-mavic-4-pro-drone-fly-more-combo-with-rc-2-remote-controller",
      //       image:
      //         "storage/e9a634deb1229cba7da7519313418ed4/dji-mavic-4-pro-001.jpg",
      //     },
      //     {
      //       title: "DJI Matrice 4TD",
      //       url: "product/dji-matrice-4td",
      //       image:
      //         "storage/cbd46675b7209c78aeded4bd25a74bdc/DJI-Matrice-4TD-001.webp",
      //     },
      //     {
      //       title: "DJI Air 3S (DJI RC-N3)",
      //       url: "product/dji-air-3s-dji-rc-n3",
      //       image:
      //         "storage/4551d153632b46ea3ecf994368bb718b/DJI-Air-3S-(DJI-RC-N3)-001.jpg",
      //     },
      //     {
      //       title: "DJI Mavic 4 Pro Flymore Combo",
      //       url: "product/dji-mavic-4-pro-drone-fly-more-combo-with-rc-2-remote-controller",
      //       image:
      //         "storage/e9a634deb1229cba7da7519313418ed4/dji-mavic-4-pro-001.jpg",
      //     },
      //     {
      //       title: "DJI Ronin 4D-6K/8K",
      //       url: "product/dji-ronin-4d-6k-8k",
      //       image: "storage/16a5ee3826c94d1773a0f23344eb494b/-001.png",
      //     },
      //     {
      //       title: "Dji Neo Motion Fly More Combo",
      //       url: "product/dji-neo-motion-fly-more-combo",
      //       image:
      //         "storage/29bd441d0ccef42b7b492949df4922ec/Dji%20Neo%20Motion%20Fly%20More%20Combo.webp",
      //     },
      //     {
      //       title: "DJI Mic 3",
      //       url: "product/dji-mic-3-compact-wireless-microphone-system-for-camera-smartphone",
      //       image:
      //         "storage/308fd41e6f2744fffbd540caa43e073e/DJI-Mic-3-2-Person-Compact-Wireless-Microphone-SystemRecorder-for-Camera-Smartphone-1-485x485-optimized.webp",
      //     },
      //     {
      //       title: "DJI RS 4 Pro Gimbal Stabilizer",
      //       url: "product/dji-rs-4-pro-gimbal-stabilizer",
      //       image:
      //         "storage/5853aff966790a3a89f5e6e57d76ddd7/94d0d3eb2550f81d2d0dd5dcc6fe3e3d@origin-1.jpg",
      //     },
      //     {
      //       title: "DJI RS 4 Mini",
      //       url: "product/dji-rs-4-mini",
      //       image:
      //         "storage/6343556fa5505abccd66fdbd187399a0/292cf8e6aed349bcf5f16b2f57b64990.jpg",
      //     },
      //     {
      //       title: "DJI Pocket 2 Creator Combo",
      //       url: "product/dji-pocket-2-creator-combo-2",
      //       image:
      //         "storage/ecf03f81d49abde752804934bf643f6f/95752848b0b65e0f53301b4c313588fc@small.jpg",
      //     },
      //     {
      //       title: "DJI Tello Standard Drone Camera",
      //       url: "product/dji-tello-standard-drone-camera",
      //       image:
      //         "storage/a7b2a1fde70ad24cc8d8a5dba0f6982a/DJI-Tello-Standard-Drone-Camera-004.png",
      //     },
      //   ],
      // },
      // {
      //   title: "Enzo",
      //   url: "category/enzo-robotics",
      //   image: "storage/f0647bba1e8cccb0e976a1a3fcad3043/Enzo.webp",
      //   nodes: [
      //     {
      //       title: "ENZO Thermal Pro",
      //       url: "product/enzo-thermal-pro-drone-indian-made-thermal-drone",
      //       image:
      //         "storage/9e1f6e62cad235154687ebae12856ffe/aircraft-front.webp",
      //     },
      //     {
      //       title: "ENZO FPV",
      //       url: "product/enzo-fpv-india-s-high-performance-drone-for-fpv-enthusiasts",
      //       image: "storage/7a89d197462cc93f984dca3f7404b7e0/aircraft.webp",
      //     },
      //     {
      //       title: "ENZO X",
      //       url: "product/enzo-x-drone-advanced-aerial-performance-with-precision-control",
      //       image: "storage/bac4f8362011acf5493d3526c1a766c3/image-1.webp",
      //     },
      //   ],
      // },
      {
        title: "Insta360",
        url: "category/insta360",
        image: "storage/408cfb603448386e6cd08e989f1294aa/Insta360.webp",
        nodes: [
          {
            title: "Insta360 ACE Pro 8K Action Camera",
            url: "product/insta360-ace-pro-8k-action-camera-with-leica-lens",
            image:
              "storage/9d98a19f9c58a7e446b3f70db14586c7/insta360-ace-pro.webp",
          },
          {
            title: "Insta360 GO 2 Action Camera",
            url: "product/insta360-go-2-action-camera",
            image:
              "storage/c6bf1de4823bc1084dcbc02e9b80b79a/insta360-go-2-action-camera.webp",
          },
          {
            title: "Insta360 Pro 2 Premium Bundle",
            url: "product/insta360-pro-2-premium-bundle",
            image:
              "storage/dcdaec80dd8c4bc9e08ffbbccadb0f22/insta-360-standard-pro-2-premium-bundle.webp",
          },
          {
            title: "Insta360 GO 3 Standalone Bundle",
            url: "product/insta360-go-3-standalone-bundle",
            image:
              "storage/6bcccd910f39ef880bdd141b5ad8690a/insta360-go-3-standalone-bundle.webp",
          },
          {
            title: "Insta360 X3 Essential Kit",
            url: "product/insta360-x3-essential-kit-with-x3-action-camera-120cm-selfie-stick",
            image:
              "storage/a902a72f124ee31e62b6edb299b510f3/insta360-x3-essential-kit-with-x3-action-camera-120cm-selfie-stick.webp",
          },
          {
            title: "Insta360 One X3 Action Camera Motorcycle Bundle",
            url: "product/insta360-one-x3-action-camera-motorcycle-bundle",
            image:
              "storage/d9b4330138ecbf708bb9387477a2c1a9/insta360-one-x3-waterproof-360-action-camera-motorcycle-bundle.webp",
          },
          {
            title: "Insta360 ONE X2 Action Camera",
            url: "product/insta360-one-x2-action-camera-extra-battery",
            image:
              "storage/a4672407a83915626a95a6a96c744916/Insta360%20ONE%20X2%20Action%20Camera%20+%20Extra%20Battery.webp",
          },
          {
            title: "Insta360 Ace Pro",
            url: "product/insta360-ace-pro",
            image:
              "storage/c8a32fac80a6c685471256ba36556d39/insta-360-ace.webp",
          },
          {
            title: "Insta360 X4 - Sports and Action Camera",
            url: "product/insta360-x4-sports-and-action-camera",
            image:
              "storage/7251d8b50fc4bdd81376580ecec44d71/insta360-x4-sports-and-action-camera.webp",
          },
          {
            title: "Insta360 One X3 Travel Kit",
            url: "product/insta360-one-x3-travel-kit",
            image:
              "storage/15a650440ba764b4582663c07940d7cc/insta360-one-x3-travel-kit.webp",
          },
          {
            title: "Insta360 X3 Creator Kit",
            url: "product/insta360-x3-creator-kit",
            image:
              "storage/27a4c1edfde3560193dedd96c340bc76/insta360%20X3%20Creator%20Kit.webp",
          },
          {
            title: "Insta360 X5",
            url: "product/insta360-x5",
            image:
              "storage/12ece8b3dffadd692483533b7961ffae/Insta360-X5-001.png",
          },
        ],
      },
      {
        title: "JSR",
        url: "category/jsr",
        image: "storage/8a89d9168f14132eb7d428818c098938/JSR.png",
        nodes: [],
      },
    ],
  },
  {
    title: "Products",
    url: "",
    nodes: [
      {
        title: "Cameras",
        url: "category/cameras",
        image: "storage/7e3d206fbf1d25d62b4604893e302711/Cameras.webp",
        nodes: [
          {
            title: "Action Camera",
            url: "category/action-cameras",
            image:
              "storage/9cbaa073743cad4866a0f88240ce0cec/Action-Camera.webp",
          },
          {
            title: "360 Degree Camera",
            url: "category/360-degree-camera",
            image: "storage/7054da8e9be286a1568a2643c11f2f07/360-Camera.png",
          },
        ],
      },
      {
        title: "Industrial Solutions",
        url: "category/industrial-solutions",
        image:
          "storage/38b3fe08045f5ea0c4897a1f21edeea3/Industrial-Solutions.png",
        nodes: [
          {
            title: "3D Scanner",
            url: "category/3d-scanner",
            image: "storage/9e5a871842cbef06dc8d8d3eb8c4ed2e/3d-Scanner.webp",
          },
          {
            title: "Hyperspectral Camera",
            url: "category/hyperspectral-camera",
            image:
              "storage/dd80e93d2fc3f1a72339c6a89941fa6e/Hyperspectral-Camera.webp",
          },
          {
            title: "Welcome Robots",
            url: "category/welcome-robots",
            image:
              "storage/a481550d2e67e8559c3fce707eaf643b/Welcome-Robots.webp",
          },
        ],
      },
      {
        title: "Robots",
        url: "category/robots",
        image: "storage/260cf8e79301c7b0681e4c9637aeba4a/Robots.webp",
        nodes: [
          {
            title: "Educational",
            url: "category/educational-robots",
            image: "storage/e6f0960d93acb31ef85957b29882ce47/Web-images--5.png",
          },
          {
            title: "Humanoids",
            url: "category/humanoids",
            image: "storage/86ae8494416934fc1a715b1bd946bea4/Humanoids.webp",
          },
          // {
          //   title: "Industrial",
          //   url: "category/industrial-robots",
          //   image:
          //     "storage/31aafb258afe6089dad9d69bc54b89f4/Industrial-Robots.png",
          // },
          {
            title: "Companion",
            url: "category/companion-robots",
            image: "storage/4202735b6fbde1f90dc9c934c2c2efa9/Companion.webp",
          },
        ],
      },
      {
        title: "Handheld",
        url: "category/handheld",
        image: "storage/9fe902b257c6bf2fe9ee4782f75bc3bd/Web-images--4.png",
        nodes: [
          {
            title: "Mobile Gimbals",
            url: "category/mobile-gimbals",
            image:
              "storage/c2af4c3d1a3a8b288dce5eef5f868180/Mobile-Gimbals.webp",
          },
          {
            title: "Camera Gimbal",
            url: "category/camera-gimbal",
            image:
              "storage/905586896296aa720ebecf5bb828bc52/Camera-Gimbal.webp",
          },
        ],
      },
      // {
      //   title: "Mic",
      //   url: "category/mic",
      //   image: "storage/93064a4d9445d87831deec37402496b9/Mic.webp",
      //   nodes: [
      //     {
      //       title: "Mic Mini",
      //       url: "category/mic-mini",
      //       image: "storage/16eeba26d4c0a6ddcae8cd9690107191/Mic-Mini.webp",
      //     },
      //     {
      //       title: "Mic 2",
      //       url: "category/mic-2",
      //       image: "storage/3ebb06dd8ffd70e66d179f3b3d19c7df/Mic-2.webp",
      //     },
      //     {
      //       title: "Mic 3",
      //       url: "category/mic-3",
      //       image: "storage/1523496994979bdb76eb80a74d09d0f1/Mic-3.webp",
      //     },
      //     {
      //       title: "Lavelier Mic",
      //       url: "category/lavelier-mic",
      //       image: "storage/bd5dc75b6bd624df7ae80dbb963f6235/Lavelier-Mic.webp",
      //     },
      //   ],
      // },
      // {
      //   title: "Drones",
      //   url: "category/drones",
      //   image: "storage/6bdb79b49c9cea6599a6e4057376a467/Drones.webp",
      //   nodes: [
      //     {
      //       title: "Consumer Series",
      //       url: "category/consumer-series",
      //       image:
      //         "storage/1cfad9651ebfb5259e5560c6ea82ed8a/Consumer-Series.webp",
      //     },
      //     {
      //       title: "Enterprise Series",
      //       url: "category/enterprise-series",
      //       image:
      //         "storage/431b4c1e2ab2966a6fc55ffc3d2a357c/Enterprise-Series.webp",
      //     },
      //     {
      //       title: "Underwater Series",
      //       url: "category/underwater-series",
      //       image:
      //         "storage/6564dd139e9d136bf458f9a9d11fd618/Underwater-Series.webp",
      //     },
      //     // {
      //     //   title: "Anti-Drone Systems",
      //     //   url: "category/anti-drone-systems",
      //     //   image:
      //     //     "storage/5e1c0b0a22b827432898214e3a94a0b0/Anti-Drone-Systems.webp",
      //     // },
      //     {
      //       title: "Payloads",
      //       url: "category/payloads",
      //       image: "storage/e313134dc71ea08233e07a14532e3e78/Payloads.webp",
      //       nodes: [
      //         {
      //           title: "Thermal",
      //           url: "category/thermal-camera",
      //           image: "storage/1bef3dfbc03b908663a50b947444841c/Thermal.webp",
      //         },
      //         {
      //           title: "Camera",
      //           url: "category/drone-camera",
      //           image:
      //             "storage/c415b108304be029763d48568fc34ed3/Web-images--3.png",
      //         },
      //         {
      //           title: "LiDAR",
      //           url: "category/lidar",
      //           image:
      //             "storage/e4065bcff02d9017674a1af654347bd4/Web-images--2.png",
      //         },
      //         {
      //           title: "Hyperspectral",
      //           url: "category/hyperspectral-camera",
      //           image:
      //             "storage/dd80e93d2fc3f1a72339c6a89941fa6e/Hyperspectral-Camera.webp",
      //         },
      //       ],
      //     },
      //   ],
      // },
      {
        title: "Accessories",
        url: "category/accessories",
        image:
          "storage/49530dfa7cc65d3387fc098b309785de/Charger%20charging%20hub%20propellor.png",
        nodes: [
          {
            title: "ND Filters",
            url: "category/nd-filters",
            image: "storage/ba1543817550251e45f37f741d8e5d01/ND-Filters.webp",
          },
          // {
          //   title: "Propellers",
          //   url: "category/propellers",
          //   image: "storage/80788987c63de12c500d115536e96d59/Propellors.webp",
          // },
          // {
          //   title: "Propeller Guard",
          //   url: "category/propeller-guard",
          //   image:
          //     "storage/1557d86fa26739a197b74e9f6e6a0a56/Propellor-Guards.webp",
          // },
          {
            title: "Screen Guard",
            url: "category/screen-guard",
            image:
              "storage/11a7ed030304030ef73bf12aee30de04/Screen-Guards.webp",
          },
          {
            title: "Batteries",
            url: "category/batteries",
            image: "storage/3e2a5b79f67c7d1dd5fc032b232945c0/Batteries.webp",
          },
          // {
          //   title: "Remote Controllers",
          //   url: "category/remote-controllers",
          //   image:
          //     "storage/c97e5ce5b0a85ea4c4abbe1e9e791bad/Remote-Controllers.webp",
          //   nodes: [
          //     {
          //       title: "Smart RC-1",
          //       url: "product/dji-rc",
          //       image: "storage/f37507eacf78151cea6921d8aeee358c/DJI%20RC.webp",
          //     },
          //     {
          //       title: "Smart RC-2",
          //       url: "product/dji-rc-2",
          //       image:
          //         "storage/f51bd992dbb93095bdbcde5e7e556322/DJI%20RC-2.webp",
          //     },
          //     {
          //       title: "Remote Controller - N1",
          //       url: "product/remote-controller-n1",
          //       image:
          //         "storage/4e969f68b017c253c6877f317156f506/Remore-Controller---N1.webp",
          //     },
          //     {
          //       title: "Remote Controller - N2",
          //       url: "product/remote-controller-n2",
          //       image:
          //         "storage/f9bab65d19f5b2aa20c1cd9bc1bcab50/Remore-Controller---N2.webp",
          //     },
          //     {
          //       title: "Remote Controller - N3",
          //       url: "product/remote-controller-n3",
          //       image:
          //         "storage/8a39c72fb7a6d6fad6f33b3d5afd8612/Remore-Controller---N3.webp",
          //     },
          //     {
          //       title: "FPV - RC3",
          //       url: "product/dji-fpv-remote-controller-3",
          //       image: null,
          //     },
          //     {
          //       title: "RC Pro",
          //       url: "product/rc-pro",
          //       image: null,
          //     },
          //     {
          //       title: "RC 2 Pro",
          //       url: "product/rc-2-pro",
          //       image: "storage/a0d96bdb4afe803c77879cf507b5f2f7/RC-2-Pro.webp",
          //     },
          //     {
          //       title: "RC - C2",
          //       url: "product/rc-c2",
          //       image: null,
          //     },
          //   ],
          // },
          // {
          //   title: "Remote Controlled Toys",
          //   url: "category/remote-controlled-toys",
          //   image:
          //     "storage/02f851f65864e5c4c33085b0c8412c10/Remote-Controlled-Toys.webp",
          //   nodes: [
          //     {
          //       title: "Cars",
          //       url: "category/remote-controlled-cars",
          //       image:
          //         "storage/064eba0e771a703497a1e7df5eca0734/Controlled-Toys.webp",
          //     },
          //     {
          //       title: "Helicopters",
          //       url: "category/remote-controlled-helicopters",
          //       image:
          //         "storage/9e299dbc94d3e0cedda81899364c79f0/Helicopters.webp",
          //     },
          //     {
          //       title: "Quadpods",
          //       url: "category/remote-controlled-quadpods",
          //       image: "storage/7dafaeacb2254b2c15f8a39292fd8293/Quadpods.webp",
          //     },
          //   ],
          // },
          // {
          //   title: "Mobiles",
          //   url: "category/mobiles",
          //   image: "storage/97d51d5237977866e036239bc490ed7c/Mobiles.webp",
          // },
          // {
          //   title: "Laptops",
          //   url: "category/laptops",
          //   image: "storage/fa537b7e732b96bb5c660ca99e6ef2da/Laptops.webp",
          //   nodes: [
          //     {
          //       title: "Kids Laptop",
          //       url: "category/kids-laptop",
          //       image:
          //         "storage/5cec6b605fceb198c2183980484c8f0c/Laptops-for-Kids.webp",
          //     },
          //     {
          //       title: "Enterprise Laptops",
          //       url: "category/enterprise-laptops",
          //       image:
          //         "storage/2ae2b3972e84875f97bfb8bbecb0323f/Enterprise-Laptops.webp",
          //     },
          //     {
          //       title: "Gaming Laptops",
          //       url: "category/gaming-laptops",
          //       image:
          //         "storage/4de76b9a7c4d49f94ea3cb9fa805c14d/Gaming-Laptops.webp",
          //     },
          //   ],
          // },
        ],
      },
    ],
  },
  {
    title: "Services",
    url: "",
    nodes: [
      {
        title: "Drone Repair",
        url: "drone-repair",
        image: "assets/drone-repair/Drone-Repair.webp",
      },
      {
        title: "Drone Services",
        url: "services",
        image: "assets/services/Drone-Services.webp",
      },
      {
        title: "Drone Pilot Training",
        url: "drone-pilot-training",
        image: "assets/drone-pilot-training/Drone-Pilot-Training.webp",
      },
    ],
  },
  {
    title: "Blogs",
    url: "blogs",
  },
  {
    title: "Contact Us",
    url: "contact-us",
  },
];

export default header;
